import styled, { css } from 'styled-components';
import { Modal } from '../../../Modal';
import { BlockingMessage as RawBlockingMessage } from '../components/BlockingMessage';
export const SettingsModal = styled(Modal) `
    position: absolute;
    right: 48px;
    bottom: 119px;
`;
SettingsModal.displayName = 'SettingsModal';
const singleRowModalStyles = css `
    width: 100%;
    height: fit-content;
    position: absolute;
    left: 0;
    bottom: 119px;
`;
export const EpisodesModal = styled(Modal) `
    ${singleRowModalStyles}
`;
EpisodesModal.displayName = 'EpisodesModal';
export const EpgModal = styled(Modal) `
    ${singleRowModalStyles}
`;
export const BlockingMessageContainer = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
export const unlockButtonStyles = {
    pointerEvents: 'auto',
    marginVertical: '24px',
};
export const BlockingMessage = styled(RawBlockingMessage) `
    font-size: 16px;
    letter-spacing: -0.18px;
    margin: 24px 0;
`;
BlockingMessage.displayName = 'BlockingMessage';
export const RelatedModal = styled(Modal) `
    ${singleRowModalStyles}
`;
EpisodesModal.displayName = 'EpisodesModal';
export const Background = styled.div `
    background-color: ${({ blockingReason }) => (blockingReason ? '#000' : 'transparent')};
`;
Background.displayName = 'Background';
export const PermanentFooter = styled.div `
    display: ${(props) => (props.hidden ? 'none' : 'flex')};
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    padding: 0 48px 118px 48px;
    pointer-events: none;
    z-index: 1;
`;
export const AdCountdownContainer = styled.div `
    display: flex;
    flex: 0 1 auto;
    align-items: center;
`;
AdCountdownContainer.displayName = 'AdCountdownContainer';
export const BingeWatchingContainer = styled.div `
    display: flex;
    flex: 0 1 auto;
    align-items: center;
    transition: opacity ease-in-out 400ms;
    opacity: ${(props) => (props.hidden ? 0 : 1)};
    pointer-events: ${(props) => (props.hidden ? 'none' : 'auto')};
`;
BingeWatchingContainer.displayName = 'BingeWatchingContainer';
//# sourceMappingURL=index.js.map